export type TabCloseAction = 'all' | 'other' | 'caughtUp';

interface TabIdAndType {
  id: string;
  type: 'conversation' | 'site' | 'client';
}

export type GetUnseenCount = (tab: TabIdAndType) => number | null;

export function getTabsToClose<T extends TabIdAndType>(input: {
  tabs: T[];
  activeId: string | null;
  action: TabCloseAction;
  getUnseenCount: GetUnseenCount;
}): T[] {
  const { tabs, activeId, action, getUnseenCount } = input;
  if (action === 'all') return tabs.slice();
  if (action === 'other') {
    if (!activeId) return tabs.slice();
    return tabs.filter((tab) => tab.id !== activeId);
  }
  return tabs.filter((tab) => tab.id !== activeId && !hasUnseenMessages(tab, getUnseenCount));
}

function hasUnseenMessages(tab: TabIdAndType, getUnseenCount: GetUnseenCount): boolean {
  if (tab.type !== 'conversation') return false;
  const count = getUnseenCount(tab);
  return count === null || count === undefined || count > 0;
}
